import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './views/login/Login';
import Space from './views/Space';
import Home from './views/Home';
import User from './views/User';
import Cate1 from './views/Cate1';
import Cate2 from './views/Cate2';
import Question from './views/Question';
import Answer from './views/Answer';
import Score from './views/Score';
import School from './views/School';
import Account from './views/Account';
import Auth from './views/Auth';
import Student from './views/Student';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/page' element={<Home />} >
          <Route path='space' element={<Space />} />
          <Route path='user' element={<User />} />
          <Route path='cate1' element={<Cate1 />} />
          <Route path='cate2' element={<Cate2 />} />
          <Route path='question' element={<Question />} />
          <Route path='answer' element={<Answer />} />
          <Route path='score' element={<Score />} />
          <Route path='school' element={<School />} />
          <Route path='student' element={<Student />} />

          <Route path='account' element={<Account />} />
          <Route path='auth' element={<Auth />} />
          
        </Route>

        
      </Routes>
    </Router>
  );
}

export default App;
